<template>
    <div class="secMenu">
        <template v-for="hostMenu in propsSidebar">
            <template v-if="hostMenu.documentChildList != null && hostMenu.documentChildList.length != 0 ">
                <li
                 :key="hostMenu.num"
                 :class="['borderLine',
                          {active : hostMenu.num == currentNum},
                          {noBorder : !hostMenu.num == currentHostNum},
                          {onDropdown : hostMenu.num == currentHostNum},
                          {onDropdown : hostMenu.num == currentHostNum}
                        ]"
                 @click="clickHostMenu(hostMenu)"
                >
                    {{hostMenu.title}}
                </li>
                <div v-if="hostMenu.num == currentHostNum" class="middleMenuGroup">
                    <template v-for="childLMenu1 in hostMenu.documentChildList">
                        <template v-if="childLMenu1.documentChildList != null && childLMenu1.documentChildList.length != 0">
                            <li
                             :key="childLMenu1.num"
                             :class="childLMenu1.num == currentNum? 'borderLine sMenuDepth2 active':'borderLine sMenuDepth2'"
                             @click="clickMiddleMenu(childLMenu1)"
                            >
                                {{childLMenu1.title}}
                            </li>
                            <div v-if="childLMenu1.num == currentMiddleNum">
                                <template v-for="childLMenu2 in childLMenu1.documentChildList">
                                    <li
                                     :class="childLMenu2.num == currentNum? 'borderLine sMenuDepth3 no-dropdown active':'borderLine sMenuDepth3 no-dropdown'"
                                     @click="clickMenu(childLMenu2);"
                                    >
                                       {{childLMenu2.title}}
                                    </li>
                                </template>
                            </div>
                        </template>
                        <li
                         v-else
                         :key="childLMenu1.num"
                         :class="childLMenu1.num == currentNum? 'borderLine sMenuDepth2 no-dropdown active':'borderLine sMenuDepth2 no-dropdown'"
                         @click="clickMiddleMenu(childLMenu1)"
                        >
                            {{childLMenu1.title}}
                        </li>
                    </template>
                    <li class="underLine"></li>
                </div>
            </template>
            <li
             v-else
             :key="hostMenu.num"
             :class="hostMenu.num == currentHostNum? 'borderLine no-dropdown active':'borderLine no-dropdown'"
             @click="clickHostMenu(hostMenu)"
            >
                {{hostMenu.title}}
            </li>

        </template>
    </div>
</template>
<script>
    export default {
        props: {
            propsSidebar: {
                type: Array,
                default: () => []
            },
            propsFirstContentNum: {
                type: Object,
                default: () => {}
            },
        },
        watch: {
            propsFirstContentNum() {
                this.currentHostNum = this.propsFirstContentNum.hostNum;
                this.currentNum = this.propsFirstContentNum.num;
            }
        },
        data() {
            return {
                currentHostNum: '',
                currentMiddleNum: '',
                currentNum: '',
            }
        },
        methods: {
            sendCurrentNum() {
                this.$emit("onChangeNum", this.currentNum);
            },
            clickHostMenu(menu) {
                this.currentHostNum = menu.num;
                this.currentMiddleNum = menu.urlNum;
                this.currentNum = menu.urlNum;
                this.sendCurrentNum();
            },
            clickMiddleMenu(menu) {
                this.currentHostNum = menu.hostNum;
                this.currentMiddleNum = menu.num;
                this.currentNum = menu.urlNum;
                this.sendCurrentNum();
            },
            clickMenu(menu) {
                this.currentHostNum = menu.hostNum;
                this.currentMiddleNum = menu.parentNum;
                this.currentNum = menu.urlNum;
                this.sendCurrentNum();
            }
        }
    }
</script>